<template>
  <div>
    <div
      :class="`${isSideBarCollapsed ? 'mc-loading-background collapsed' : 'mc-loading-background'}`"
    >
      <div v-if="isTimeout" class="mc-loading-timeout">
        <div class="mc-loading-container">
          <h5>{{ $t('global.loader.timeoutTitle') }}</h5>
          <span class="text-muted">{{ $t('global.loader.timeoutSubtitle') }}</span>
          <McButton text="Reload" @click="handleReload" />
        </div>
      </div>
      <div v-else>
        <div v-if="imgType == 'LoadingBar'" class="mc-loading_bar">
          <div class="mc-loading-bar_container">
            <h5 v-if="showText">
              {{ title }}
            </h5>
            <div class="progress-bar">
              <div class="progress" :style="{ width: `${progress}%` }">
                <span class="progress-text">{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span v-if="showText" class="text-muted"> {{ subTitle }}</span>
          </div>
        </div>
        <div v-else :class="showText ? 'mc-loading-with_text' : 'mc-loading-no_text'">
          <img :src="imageUrl.url" :alt="imageUrl.alt" />
          <span v-if="showText"> {{ subTitle }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    isDefault: {
      type: Boolean,
      default: true,
    },
    maxProgress: {
      type: Number,
      default: 0,
    },
    timeoutDuration: {
      type: Number,
      default: 60000,
    },
    imgType: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: this.$t('global.loader.pleaseWait'),
    },
  },
  data() {
    return {
      showText: false,
      progress: 0,
      isTimeout: false,
      startTime: null,
      timeoutId: null,
      timeoutTimer: null,
      textTimer: null,
    }
  },
  computed: {
    isSideBarCollapsed() {
      return !document.body.classList.contains('right-bar-enabled')
    },
    imageUrl() {
      if (this.imgType === 'McEasyLogo') {
        return {
          url: 'https://s3-alpha-sig.figma.com/img/fd28/e103/cad93cfbafc51d137a3f8226c56f7ba5?Expires=1742169600&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=qqFqISl6py-cH9fV2pYrjUuXM5obzoL-fRBxZrLNLb-KLlzL3cP-bzAQ8PjM9D0DBIR4~hSQ0EgPPBhmV6xt8aHMrdF3wOZULj7K4LTDl1tgL-H8NuHPX5eMKxD2p3XgSZGlB0XbdP2bVhdL~SyGu9U5e9SNbj4-HObNyRobfpyAHk5JHzub5td-W0JmK81A-DSPXPVeYxA1irQWvhXrERE-CFTqtQnbVuvcPxgq-RH9dRo869bWlCjOni6NNgz8nVO7pvDZc~xNKy-os2gh132j~LoiBys-16IUCcpbeycSPhcEY655oSsKI7RnqXYB1DRfHjCt6i8RALqM5GZEJA__',
          alt: 'logoME',
        }
      } else {
        return {
          url: require('./assets/circular.gif'),
          alt: 'spinner',
        }
      }
    },
  },

  watch: {
    progress(value) {
      if (value >= 100) {
        clearTimeout(this.timeoutTimer)
        cancelAnimationFrame(this.animationFrame)
        this.$emit('close')
      }
    },
    maxProgress(value) {
      if (value >= 0) {
        this.progress = value
        this.$el.querySelector('.progress').style.width = `${value}%`
      }
      if (value >= 100) {
        clearTimeout(this.timeoutTimer)
        this.$emit('close')
      }
    },
  },

  created() {
    this.startTime = Date.now()
    if (this.isDefault) {
      this.startDefaultProgress()
    } else {
      if (this.imgType === 'LoadingBar') {
        setTimeout(() => {
          this.showText = true
        }, 10000)
      } else {
        setTimeout(() => {
          this.showText = true
        }, 3000)
      }
    }

    this.startTimeoutTimer()
  },

  beforeDestroy() {
    clearTimeout(this.timeoutTimer)
    clearTimeout(this.textTimer)
  },

  methods: {
    startDefaultProgress() {
      if (this.imgType === 'LoadingBar') {
        this.progress = 0
        this.startTime = Date.now()
        let lastProgress = 0

        const animate = () => {
          const elapsedTime = Date.now() - this.startTime
          let progress = 0

          if (elapsedTime <= 3000) {
            progress = (elapsedTime / 3000) * 69
          } else if (elapsedTime <= 10000) {
            progress = 69 + ((elapsedTime - 3000) / 7000) * 8
          } else {
            progress = 77
            cancelAnimationFrame(this.animationFrame)
            return
          }

          progress = Math.min(Math.round(progress), 77)
          if (progress !== lastProgress) {
            this.progress = progress
            this.$el.querySelector('.progress').style.width = `${progress}%`
            lastProgress = progress
          }

          this.animationFrame = requestAnimationFrame(animate)
        }

        this.animationFrame = requestAnimationFrame(animate)

        setTimeout(() => {
          this.showText = true
        }, 10000)
      } else {
        setTimeout(() => {
          this.showText = true
        }, 3000)
      }
    },
    startCustomProgress() {
      this.progress = this.maxProgress
    },
    startTimeoutTimer() {
      if (this.progress >= 100) {
        this.isTimeout = false
        return
      }
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
      this.timeoutId = setTimeout(() => {
        if (this.progress < 100) {
          this.isTimeout = true
        }
      }, this.timeoutDuration)
    },

    handleReload() {
      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss">
.mc-loading-background {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(13, 68, 145, 0.24);
  width: 100%;
  height: calc(100vh - 110px);

  &.collapsed {
    width: 100%;
  }

  .mc-loading-timeout {
    .mc-loading-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-width: 400px;
      min-height: 197px;
      border-radius: 8px;
      background-color: white;
      padding: 16px;
      gap: 8px;
    }
  }

  .mc-loading_bar {
    width: 335px; // Original width
    height: 96px; // Original height from lines 252-253

    .mc-loading-bar_container {
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 128px;
      min-height: 128px; // Original height
      border-radius: 8px;
      background-color: white;
      padding: 16px;

      .progress-bar {
        width: 100%;
        height: 20px;
        background: #e0e0e0;
        border-radius: 10px;
        overflow: hidden;
        margin: 16px 0;

        .progress {
          height: 100%;
          background: $mep-primary;
          transition: width 0.25s ease;
          position: relative;

          .progress-text {
            position: absolute;
            right: 8px;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }

  .mc-loading-no_text {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 128px;
    min-height: 128px;
    border-radius: 8px;
    background-color: white;
    padding: 16px;
    gap: 4px;
    img {
      width: 96px;
    }
  }
  .mc-loading-with_text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-width: 124px;
    min-height: 144px;
    border-radius: 8px;
    background-color: white;
    padding: 12px;
    gap: 4px;
    font-size: 12px;
    span {
      align-items: flex-end;
      margin-top: auto;
    }
    img {
      width: 96px;
    }
  }
}
</style>
